import styled, { keyframes } from 'styled-components';

const reveal = keyframes`
	from 				{opacity: 0;}
	to 					{opacity: 1;}
`;

export const InvalidMessageWrapper = styled.div`
  animation: ${reveal} 0.2s linear forwards;
  position: relative;
  font-size: ${(props) => props.theme.x1space + 0.4}rem;
  > span {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    background: ${(props) => props.theme.color.badRGBA(0.9)};
    color: white;
    padding: 2px 4px;
  }
`;
